<template>
    <guide-page :config="pageConfig" :wxa-page="wxaPage" :wxa-page-param="wxaPageParam" :shareHaderName="shareHaderName"></guide-page>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import GuidePage from '../component/GuidePage.vue';

export default {
  name: 'AccountApplication',
  components: {
    'guide-page': GuidePage,
  },
  data() {
    return {
      wxaPage: 'pages/me/guide/guide-page/guide-page',
      wxaPageParam: 'key=1',
      shareHaderName: '账号申请',
      pageConfig: {
        sections: [
          {
            steps: [
              {
                description: [
                  '登录666visa.cn，点击「账号申请」进入账号申请页；',
                ],
                sub: [
                  {
                    images: [
                      {
                        name: '1_01',
                        align: 'left',
                      },
                    ],
                  },
                ],
              },
              {
                description: [
                  '填写基本信息、上传名片，点击「提交」即可。平台在收到申请的1个工作日内完成审核开户操作，并通过短信及邮件同步提醒。',
                ],
                sub: [
                  {
                    images: [
                      {
                        name: '1_02',
                        align: 'left',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    };
  },
  mounted() {
    sensorsdata.track('UserGuide', {
      guide_name: '账号申请',
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/guide/sub/AccountApplication.vue